module.exports = __webpack_public_path__ + "images/dvd-videofilmer.b52f47f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/dvd-videofilmer.jpg
// module id = d61fc13a
// module chunks = 10 37